const cropManagementQuestionnaire = {
    "title": "作物管理",
    "sections": [
        {
            "subject": "病蟲草害防治資材使用",
            "questions": [
                {
                    "description": "是否使用病蟲草害資材進行管理?",
                    "type": "scq",
                    "options": ["是", "否"],
                    "questions": [
                        {
                            "condition": "是",
                            "description": "請填寫”病蟲草害防治資材使用列表",
                            "type": "oeq",
                            "format": {
                                "multiple": true,
                                "fields": ["資材名稱", "病/蟲/草害:病害|蟲害|草害", "防治對象", "原料", "允用/限用/禁用:允用|限用|禁用", "含基改成分:是|否"]
                            }
                        }
                    ]
                }
            ]
        },
        {
            "subject": "雜草管理計畫",
            "questions": [
                {
                    "description": "是否有雜草管理?",
                    "type": "scq",
                    "options": ["是", "否"],
                    "questions": [
                        {
                            "condition": "是",
                            "description": "您有哪些雜草問題?",
                            "type": "oeq"
                        },
                        {
                            "condition": "是",
                            "description": "您使用的雜草防治方法?",
                            "type": "mcq",
                            "options": ["輪作", "延遲播種", "割草", "整地", "機器除草", "使用快速新興品種", "土壤消毒", "人工割草", "火焰除草",
                                "拔草", "放牧", "覆蓋作物", "管控土壤溫度", "皂液除草劑", "預防雜草種子結實", "合成物質敷", "非合成物質敷蓋", {"value": "其他(需再說明)", "elaboration": "請說明"}]
                        },
                        {
                            "condition": "是",
                            "description": "您是否保有雜草防治的作業紀錄?",
                            "type": "scq",
                            "options": ["是", "否"]
                        },
                        {
                            "condition": "是",
                            "description": "是否使用塑膠或其它合成敷蓋物?",
                            "type": "scq",
                            "options": ["是", "否"],
                            "questions": [
                                {
                                    "condition": "是",
                                    "description": "如是,是否在收成後完全移除?",
                                    "type": "scq",
                                    "options": ["是", "否"]
                                }
                            ]
                        },
                        {
                            "condition": "是",
                            "description": "是否使用皂液除草劑?",
                            "type": "scq",
                            "options": ["是", "否"],
                            "questions": [
                                {
                                    "condition": "是",
                                    "description": "如是,請列出使用區域",
                                    "type": "oeq",
                                }
                            ]
                        },
                        {
                            "condition": "是",
                            "description": "是否使用報紙或回收紙做為敷蓋物?",
                            "type": "scq",
                            "options": ["是", "否"],
                            "questions": [
                                {
                                    "condition": "是",
                                    "description": "如是,是否使用光滑或彩色油墨的紙?",
                                    "type": "scq",
                                    "options": ["是", "否"]
                                }
                            ]
                        },
                        {
                            "condition": "是",
                            "description": "您如何監控雜草管理計畫成效?",
                            "type": "mcq",
                            "options": ["觀察雜草種類", "比較作物產量", "紀錄", {"value": "其它", "elaboration": "請說明"}],
                        },
                        {
                            "condition": "是",
                            "description": "多久做一次雜草管理計畫的監控?",
                            "type": "scq",
                            "options": ["每週", "每月", "每年", "需要時",  {"value": "其它", "elaboration": "請說明"}]
                        }
                    ]
                }
            ]
        },
        {
            "subject": "有害生物管理計畫",
            "questions": [
                {
                    "description": "農場內主要的有害生物種類?",
                    "type": "mcq",
                    "options": ["鼠害", "地鼠", "鳥害", {"value": "蟲害", "elaboration": "請列出"}, {"value": "其他動物", "elaboration": "其他動物"}]
                },
                {
                    "description": "如何監控有害生物管理成效?",
                    "type": "mcq",
                    "options": ["以誘餌監控昆蟲數量", "作物品質測試", "觀察作物健康情形", "保存監控紀錄", "比較作物產量", "其他"]
                },
                {
                    "description": "多久做一次有害生物管理的監控?",
                    "type": "scq",
                    "options": ["每週", "每月", "每年", "需要時",  {"value": "其它", "elaboration": "請說明"}]
                },
            ]
        },
        {
            "subject": "病害管理計畫",
            "questions": [
                {
                    "description": "請說明病害問題?",
                    "type": "oeq"
                },
                {
                    "description": "請說明您所採取的病害防治措施?",
                    "type": "mcq",
                    "options": ["輪作", "均衡土壤", "植株間隔控制", "田間衛生維護", "調整栽植期", "病媒管理", "日曬消毒", "混作",
                        "使用堆/液肥", "使用允用資材", "使用限用資材", "作物品種選擇", "有條件的使用禁用資材", {"value": "其它(需再說明)", "elaboration": "請說明"}],
                },
                {
                    "description": "您如何監控病害管理的成效?",
                    "type": "mcq",
                    "options": ["土壤分析", "微生物分析", "土壤觀察", "觀察作物健康", "比較作物產量", "作物品質測試", "保存監控紀錄", {"value": "其它(需再說明)", "elaboration": "請說明"}]
                },
                {
                    "description": "如適用，請附上測試結果",
                    "type": "oeq",
                    "format": {
                        "multiple": false,
                        "fields": ["上傳檔案:file, optional"]
                    }
                },
                {
                    "description": "多久做一次病害的監控?",
                    "type": "scq",
                    "options": ["每週", "每月", "每年", "需要時",  {"value": "其它", "elaboration": "請說明"}]
                }

            ]
        },
    ]
}

export default cropManagementQuestionnaire;